import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "Turborepo 1.11",
  "description": "Turborepo 1.11은 Turborepo의 미래를 위한 Rust 기반 기초를 확립합니다.",
  "date": "2023/12/05",
  "tag": "web development"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "Turborepo 1.11은 Rust로의 마이그레이션을 완료하고 여러 개발자 경험 개선 사항을 제공합니다:"
  }, {
    "heading": "",
    "content": "새로운 Rust 기반 기초: Go에서의 포팅을 완료하여 더 나은 성능, 향상된 안정성 및 새로운 기능을 위한 토대를 마련했습니다."
  }, {
    "heading": "",
    "content": "가독성 향상을 위한 로그 그룹화: 이제 --log-order=grouped를 지정하여 로그를 작업별로 구분된 별개의 섹션으로 구성할 수 있습니다."
  }, {
    "heading": "",
    "content": "업데이트된 예제: Next.js, Svelte, Remix, Nuxt 등의 예제로 시작하세요."
  }, {
    "heading": "",
    "content": "npx @turbo/codemod migrate를 실행하여 오늘 업데이트하세요."
  }, {
    "heading": "rust로-turbo의-미래-열기",
    "content": "마이그레이션에 대한 블로그 포스트에서 작성했듯이, Turborepo 사용자를 위한 포팅 노력의 이점을 보기 시작하게 되어 기쁩니다. Rust를 통해 우리 코드에서 더 많은 복잡성을 표면화할 수 있게 되어 여러 방식으로 여러분의 코드베이스에서 더 나은 경험을 만들 수 있습니다:"
  }, {
    "heading": "rust로-turbo의-미래-열기",
    "content": "아직 코드에서 많은 성능 튜닝을 하지 않았음에도 일부 사용 사례에서 즉시 약간의 성능 향상을 발견했습니다. turbo를 곧 훨씬 더 빠르게 만드는 것을 더 깊이 탐구하기를 기대합니다."
  }, {
    "heading": "rust로-turbo의-미래-열기",
    "content": "globbing, 경로 및 인코딩 지원의 부수적인 동작을 테스트되고 지원되는 동작으로 옮길 수 있어, 예상대로 구성을 처리하고 있다는 확신을 얻을 수 있습니다. 앞으로 검증 및 자동 버그 수정 codemod와 같은 기능을 Turborepo에 구축하여 더 나은 안정성을 확보할 수 있습니다."
  }, {
    "heading": "rust로-turbo의-미래-열기",
    "content": "다음 릴리스의 기능으로 모노레포에서 오류 메시지를 향상시키는 작업을 빠르게 반복하여 잘못된 구성의 원인을 찾는 데 중요한 정보를 제공합니다."
  }, {
    "heading": "rust로-turbo의-미래-열기",
    "content": "Rust는 Go보다 플랫폼과 환경 간의 차이를 훨씬 더 면밀히 생각하도록 강제하기 때문에 플랫폼 관련 가능한 버그를 훨씬 더 빨리 포착할 수 있습니다. 이러한 심화된 신뢰성은 저장소에서 가능한 버그의 전체 범주를 제거합니다."
  }, {
    "heading": "rust로-turbo의-미래-열기",
    "content": "새 Rust 코드 경로와 관련이 있다고 생각되는 문제를 발견하면 --go-fallback 플래그를 사용하여 Go 코드 경로로 다시 전환하고 GitHub에 이슈를 보고할 수 있습니다."
  }, {
    "heading": "가독성-향상을-위한-로그-그룹화",
    "content": "작업 로그를 더 쉽게 검토할 수 있도록 작업에서 작성하는 동안이 아니라 완료된 후 모든 로그를 출력하는 --log-order 플래그를 도입했습니다. 이를 통해 작업별로 구분된 로그가 생성되어 특정 작업의 로그에 대한 가독성이 향상됩니다."
  }, {
    "heading": "가독성-향상을-위한-로그-그룹화",
    "content": "--log-order=grouped를 사용하여 이 동작을 활성화하세요. 자세한 내용은 문서를 확인하세요"
  }, {
    "heading": "업데이트된-예제",
    "content": "저장소에는 프로젝트를 위한 스타터 모노레포가 포함된 예제 디렉토리가 있습니다."
  }, {
    "heading": "업데이트된-예제",
    "content": "예제로 시작하려면 다음을 실행하세요:"
  }, {
    "heading": "업데이트된-예제",
    "content": "예제를 최신 상태로 유지하기 위해 새로운 노력을 기울이고 있습니다. 또한 모노레포의 모범 사례를 옹호하기 위해 예제를 재설계했습니다. 예를 들어:"
  }, {
    "heading": "업데이트된-예제",
    "content": "패키지 간 편집기 내 정의로 이동"
  }, {
    "heading": "업데이트된-예제",
    "content": "최신 버전으로 업데이트된 종속성"
  }, {
    "heading": "업데이트된-예제",
    "content": "ESLint, Prettier, jest, vitest와 같은 도구가 사전 구성됨"
  }, {
    "heading": "업데이트된-예제",
    "content": "패키지 간 핫 리로딩"
  }, {
    "heading": "업데이트된-예제",
    "content": "시작하려면 예제를 사용하거나 자세한 내용은 코드를 직접 탐색하세요."
  }, {
    "heading": "커뮤니티",
    "content": "Turborepo 1.10 출시 이후 놀라운 채택률과 커뮤니티 성장을 보았습니다:"
  }, {
    "heading": "커뮤니티",
    "content": "23.6k+ GitHub Stars"
  }, {
    "heading": "커뮤니티",
    "content": "주간 NPM 다운로드 1.8M+회"
  }, {
    "heading": "커뮤니티",
    "content": "Vercel의 Remote Caching을 통해 206년의 컴퓨팅 시간 절약"
  }, {
    "heading": "커뮤니티",
    "content": "Turborepo는 핵심 팀을 포함한 모든 기여자들의 노력이 결합된 결과입니다."
  }, {
    "heading": "커뮤니티",
    "content": "Turborepo를 여러분의 빌드 도구로 선택하기 위해 지속적인 지원, 피드백, 협업에 감사드립니다."
  }],
  "headings": [{
    "id": "rust로-turbo의-미래-열기",
    "content": "Rust로 turbo의 미래 열기"
  }, {
    "id": "가독성-향상을-위한-로그-그룹화",
    "content": "가독성 향상을 위한 로그 그룹화"
  }, {
    "id": "업데이트된-예제",
    "content": "업데이트된 예제"
  }, {
    "id": "커뮤니티",
    "content": "커뮤니티"
  }]
};
import {Authors} from '#components/authors';
import {ThemeAwareImage} from '#components/theme-aware-image';
import {Date} from '#components/blog/date';
export const toc = [{
  depth: 2,
  url: "#rust로-turbo의-미래-열기",
  title: _jsxs(_Fragment, {
    children: ["Rust로 ", _jsx("code", {
      children: "turbo"
    }), "의 미래 열기"]
  })
}, {
  depth: 2,
  url: "#가독성-향상을-위한-로그-그룹화",
  title: _jsx(_Fragment, {
    children: "가독성 향상을 위한 로그 그룹화"
  })
}, {
  depth: 2,
  url: "#업데이트된-예제",
  title: _jsx(_Fragment, {
    children: "업데이트된 예제"
  })
}, {
  depth: 2,
  url: "#커뮤니티",
  title: _jsx(_Fragment, {
    children: "커뮤니티"
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    em: "em",
    h2: "h2",
    li: "li",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx("h1", {
      className: "text-center",
      children: "Turborepo 1.11"
    }), "\n", "\n", _jsx(Date, {
      children: "Tuesday, December 5th, 2023"
    }), "\n", _jsx(Authors, {
      authors: ['gregsoltis', 'chrisolszewski', 'nicholasyang', 'alexanderlyon']
    }), "\n", _jsx(_components.p, {
      children: "Turborepo 1.11은 Rust로의 마이그레이션을 완료하고 여러 개발자 경험 개선 사항을 제공합니다:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#unlocking-the-future-of-turbo-with-rust",
          children: _jsx(_components.strong, {
            children: "새로운 Rust 기반 기초"
          })
        }), ": Go에서의 포팅을 완료하여 더 나은 성능, 향상된 안정성 및 새로운 기능을 위한 토대를 마련했습니다."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#group-logs-for-improved-readability",
          children: _jsx(_components.strong, {
            children: "가독성 향상을 위한 로그 그룹화"
          })
        }), ": 이제 ", _jsx(_components.code, {
          children: "--log-order=grouped"
        }), "를 지정하여 로그를 작업별로 구분된 별개의 섹션으로 구성할 수 있습니다."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#updated-examples",
          children: _jsx(_components.strong, {
            children: "업데이트된 예제"
          })
        }), ": Next.js, Svelte, Remix, Nuxt 등의 예제로 시작하세요."]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "npx @turbo/codemod migrate"
      }), "를 실행하여 오늘 업데이트하세요."]
    }), "\n", _jsxs(_components.h2, {
      id: "rust로-turbo의-미래-열기",
      children: ["Rust로 ", _jsx(_components.code, {
        children: "turbo"
      }), "의 미래 열기"]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "https://vercel.com/blog/turborepo-migration-go-rust",
        children: "마이그레이션에 대한 블로그 포스트"
      }), "에서 작성했듯이, Turborepo 사용자를 위한 포팅 노력의 이점을 보기 시작하게 되어 기쁩니다. Rust를 통해 ", _jsx(_components.em, {
        children: "우리"
      }), " 코드에서 더 많은 복잡성을 표면화할 수 있게 되어 여러 방식으로 ", _jsx(_components.em, {
        children: "여러분의"
      }), " 코드베이스에서 더 나은 경험을 만들 수 있습니다:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["아직 코드에서 많은 성능 튜닝을 하지 않았음에도 일부 사용 사례에서 즉시 약간의 성능 향상을 발견했습니다. ", _jsx(_components.code, {
          children: "turbo"
        }), "를 ", _jsx(_components.strong, {
          children: "곧 훨씬 더 빠르게"
        }), " 만드는 것을 더 깊이 탐구하기를 기대합니다."]
      }), "\n", _jsxs(_components.li, {
        children: ["globbing, 경로 및 인코딩 지원의 부수적인 동작을 테스트되고 지원되는 동작으로 옮길 수 있어, 예상대로 구성을 처리하고 있다는 확신을 얻을 수 있습니다. 앞으로 검증 및 자동 버그 수정 codemod와 같은 기능을 Turborepo에 구축하여 ", _jsx(_components.strong, {
          children: "더 나은 안정성"
        }), "을 확보할 수 있습니다."]
      }), "\n", _jsxs(_components.li, {
        children: ["다음 릴리스의 기능으로 모노레포에서 ", _jsx(_components.strong, {
          children: "오류 메시지를 향상"
        }), "시키는 작업을 빠르게 반복하여 잘못된 구성의 원인을 찾는 데 중요한 정보를 제공합니다."]
      }), "\n", _jsxs(_components.li, {
        children: ["Rust는 Go보다 플랫폼과 환경 간의 차이를 훨씬 더 면밀히 생각하도록 강제하기 때문에 플랫폼 관련 가능한 버그를 훨씬 더 빨리 포착할 수 있습니다. 이러한 ", _jsx(_components.strong, {
          children: "심화된 신뢰성"
        }), "은 저장소에서 가능한 버그의 전체 범주를 제거합니다."]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["새 Rust 코드 경로와 관련이 있다고 생각되는 문제를 발견하면 ", _jsx(_components.code, {
        children: "--go-fallback"
      }), " 플래그를 사용하여 Go 코드 경로로 다시 전환하고 ", _jsx(_components.a, {
        href: "https://github.com/vercel/turbo/issues/new?assignees=&labels=kind%3A+bug%2Cowned-by%3A+turborepo%2Cneeds%3A+triage&projects=&template=0-turborepo-bug-report.yml&title=%5Bturborepo%5D+",
        children: "GitHub에 이슈를 보고"
      }), "할 수 있습니다."]
    }), "\n", _jsx(_components.h2, {
      id: "가독성-향상을-위한-로그-그룹화",
      children: "가독성 향상을 위한 로그 그룹화"
    }), "\n", _jsxs(_components.p, {
      children: ["작업 로그를 더 쉽게 검토할 수 있도록 작업에서 ", _jsx(_components.em, {
        children: "작성하는 동안"
      }), "이 아니라 ", _jsx(_components.strong, {
        children: "완료된 후"
      }), " 모든 로그를 출력하는 ", _jsx(_components.code, {
        children: "--log-order"
      }), " 플래그를 도입했습니다. 이를 통해 작업별로 구분된 로그가 생성되어 특정 작업의 로그에 대한 가독성이 향상됩니다."]
    }), "\n", _jsx(ThemeAwareImage, {
      className: "my-4 flex justify-center",
      light: {
        alt: 'Using `--log-order=grouped` to output task logs to the terminal as separated chunks separated by task.',
        src: '/images/blog/turbo-1-11-0/log-order-groups-light.png',
        props: {
          width: 682,
          height: 746.5,
          className: 'dark:hidden block rounded-xl'
        }
      },
      dark: {
        alt: 'Using `--log-order=grouped` to output task logs to the terminal as separated chunks separated by task.',
        src: '/images/blog/turbo-1-11-0/log-order-groups-dark.png',
        props: {
          width: 682,
          height: 746.5,
          className: 'hidden dark:block rounded-xl'
        }
      }
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "--log-order=grouped"
      }), "를 사용하여 이 동작을 활성화하세요. 자세한 내용은 ", _jsx(_components.a, {
        href: "/docs/reference/run#--log-order-option",
        children: "문서"
      }), "를 확인하세요"]
    }), "\n", _jsx(_components.h2, {
      id: "업데이트된-예제",
      children: "업데이트된 예제"
    }), "\n", _jsxs(_components.p, {
      children: ["저장소에는 프로젝트를 위한 스타터 모노레포가 포함된 ", _jsx(_components.a, {
        href: "https://github.com/vercel/turbo/tree/main/examples",
        children: _jsx(_components.code, {
          children: "예제 디렉토리"
        })
      }), "가 있습니다."]
    }), "\n", _jsx(_components.p, {
      children: "예제로 시작하려면 다음을 실행하세요:"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# 두 개의 Next.js 애플리케이션"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "npx"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " create-turbo@latest"
            })]
          })]
        })
      })
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# Next.js와 Remix"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "npx"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " create-turbo@latest"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " -e"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " kitchen-sink"
            })]
          })]
        })
      })
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# Vue와 Nuxt"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "npx"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " create-turbo@latest"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " -e"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " with-vue-nuxt"
            })]
          })]
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "예제를 최신 상태로 유지하기 위해 새로운 노력을 기울이고 있습니다. 또한 모노레포의 모범 사례를 옹호하기 위해 예제를 재설계했습니다. 예를 들어:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "패키지 간 편집기 내 정의로 이동"
      }), "\n", _jsx(_components.li, {
        children: "최신 버전으로 업데이트된 종속성"
      }), "\n", _jsx(_components.li, {
        children: "ESLint, Prettier, jest, vitest와 같은 도구가 사전 구성됨"
      }), "\n", _jsx(_components.li, {
        children: "패키지 간 핫 리로딩"
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["시작하려면 ", _jsx(_components.a, {
        href: "/docs/getting-started/examples",
        children: "예제를 사용"
      }), "하거나 자세한 내용은 ", _jsx(_components.a, {
        href: "https://github.com/vercel/turbo/tree/main/examples",
        children: "코드를 직접 탐색"
      }), "하세요."]
    }), "\n", _jsx(_components.h2, {
      id: "커뮤니티",
      children: "커뮤니티"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "/blog/turbo-1-10-0",
        children: "Turborepo 1.10"
      }), " 출시 이후 놀라운 채택률과 커뮤니티 성장을 보았습니다:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "https://github.com/vercel/turbo",
          children: "23.6k+ GitHub Stars"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "https://www.npmjs.com/package/turbo",
          children: "주간 NPM 다운로드 1.8M+회"
        })
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "https://vercel.com/docs/concepts/monorepos/remote-caching",
          children: "Vercel의 Remote Caching"
        }), "을 통해 206년의 컴퓨팅 시간 절약"]
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "Turborepo는 핵심 팀을 포함한 모든 기여자들의 노력이 결합된 결과입니다."
    }), "\n", _jsx(_components.p, {
      children: "Turborepo를 여러분의 빌드 도구로 선택하기 위해 지속적인 지원, 피드백, 협업에 감사드립니다."
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
